import { useNavigate } from 'react-router-dom';
import { Store, Image, Clock } from 'lucide-react';
import bagIcon from '../../assets/img/bag.svg';
import { useCartStore } from '../../store/useCartStore';
import { useUIStore } from '../../store/useUIStore';
import { useStoreInfo } from '../../store/useStoreInfo';
import { normalizeStoreAssetUrl } from '../../lib/mediaUrl';
import * as S from './styles';

const Header = () => {
  const navigate = useNavigate();
  const { activeFilter, setFilter } = useUIStore();
  const count = useCartStore((state) => state.count);
  const { data: storeData, isLoading } = useStoreInfo();

  // استخدام الشعار والبنر من بيانات المتجر (توحيد // و CDN القديم؛ بدون crossOrigin لتفادي فشل التحميل)
  const logoImg = normalizeStoreAssetUrl(storeData?.logo);
  const bannerImg = normalizeStoreAssetUrl(storeData?.banner);
  const hasLogo = logoImg && logoImg.length > 0;
  const hasBanner = bannerImg && bannerImg.length > 0;
  const isBusy = storeData?.busy === true;

  return (
    <S.StoreHeaderContainer>
      <S.Banner>
        {isLoading ? (
          <S.SkeletonBanner />
        ) : hasBanner ? (
          <S.BannerImg
            key={`${bannerImg}|${storeData?.updatedAt ?? ''}`}
            src={bannerImg}
            alt="banner"
          />
        ) : (
          <S.BannerPlaceholder>
            <Image size={48} color="oklch(55.44% 0.041 257.42)" strokeWidth={1.5} />
          </S.BannerPlaceholder>
        )}
        
        <S.CartHeaderContainer>
          <S.CartBtnHeader onClick={() => navigate('/checkout')}>
            <S.CartIconWrapper>
              <S.CartIconImg src={bagIcon} alt="Cart" />
            </S.CartIconWrapper>
            {count > 0 && <S.CartCountBadge>{count}</S.CartCountBadge>}
          </S.CartBtnHeader>
        </S.CartHeaderContainer>
      </S.Banner>

      <S.DeliverySettings $active={activeFilter}>
        <S.ToggleButton 
          onClick={() => setFilter('all')}
          $isActive={activeFilter === 'all'}
        >
          الكل
        </S.ToggleButton>
        <S.ToggleButton 
          onClick={() => setFilter('offers')}
          $isActive={activeFilter === 'offers'}
        >
          العروض
        </S.ToggleButton>
      </S.DeliverySettings>

      <S.LogoContainer $logoUrl={hasLogo ? logoImg : undefined}>
        {isLoading ? (
          <S.SkeletonLogo />
        ) : hasLogo ? (
          <S.StoreLogo
            key={`${logoImg}|${storeData?.updatedAt ?? ''}`}
            src={logoImg}
            alt="Store Logo"
          />
        ) : (
          <S.LogoPlaceholder>
            <Store size={28} color="oklch(55.44% 0.041 257.42)" strokeWidth={1.5} />
          </S.LogoPlaceholder>
        )}
        {!isLoading && isBusy && (
          <S.BusyBadge role="img" aria-label="المتجر مشغول حالياً">
            <Clock size={12} strokeWidth={2.75} />
          </S.BusyBadge>
        )}
      </S.LogoContainer>
    </S.StoreHeaderContainer>
  );
};

export default Header;
